<template>
  <div class="select-group" role="group">
    <input @change="change" type="radio" value="0" class="btn-check" :name="name" id="modeView0"
           autocomplete="off" :checked="getChecked(0)">
    <label class="select-group-btn" for="modeView0">
      <svg class="svgicon rotate" aria-hidden="true" focusable="false">
        <use xlink:href="/svg/schedule.sprite.svg?v=2#square6"></use>
      </svg>
    </label>
      <input @change="change" type="radio" value="1" class="btn-check" :name="name" id="modeView1"
             autocomplete="off" :checked="getChecked(1)">
      <label class="select-group-btn" for="modeView1">
        <svg class="svgicon" aria-hidden="true" focusable="false">
          <use xlink:href="/svg/schedule.sprite.svg?v=1#squareLine"></use>
        </svg>
      </label>
  </div>
</template>

<script>
import {API} from "@/getapi";

export default {
  name: "BtnGroupMode",
  inject: ['URL_SENDMODE'],
  props: {
    name: String
  },
  data() {
    return {
      checked: 1
    }
  },
  created() {
    this.x = this.$store.state.vMode;
    if (!this.$store.state.vMode) {
      this.$store.state.vMode = 0;
      this.$cookies.set('vMode', 0, Infinity);
    }
    console.log(this.$store.state.vMode)
    this.sendMode({'u_vmode':this.$store.state.vMode})
  },
  methods: {
    change: function (e) {
      e.preventDefault();
      let value = e.currentTarget.value
      this.$store.state.vMode = value;
      this.$store.dispatch('setVMode', value);
      this.$cookies.set('vMode', value, Infinity);
      this.$emitter.emit('changevMode')
      this.sendMode({'u_vmode':value})


    },
    sendMode(saveData){
      API.get(this.URL_SENDMODE, saveData).then(({data}) => {

        if (data.isOk) {
          let dataResult = data.result
          console.log(dataResult)
        } else {
          console.error("Error:", data.errors)
        }
      }).catch((err) => {
        API.catch(err)
      })
    },
    getChecked: function (num) {
      if (num == this.$store.state.vMode) {
        return true;
      }
      return false
    }
  },
}
</script>

<style scoped>
.svgicon{
  position: relative;
  width: 1em;
  height: 1em;
  top:-1px;
}
.svgicon.rotate{
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}

.select-group {
  display: inline-flex;

}

.select-group .select-group-btn {
  border: 1px solid #E07A5F;
  border-right: none;
  padding: 8px 8px;
  border-radius: 0px;
  font-size: .9rem;
  line-height: 1rem;
  background: #FFFFFF;
  cursor: pointer;
  transition: background-color ease 300ms;
  user-select: none;
}
.select-group .select-group-btn:hover{
  background: #ffd0c4;
}

.select-group .select-group-btn:last-child {
  border-right: 1px solid #E07A5F;
  border-radius: 0px 5px 5px 0px;
}

.select-group .btn-check:first-child + .select-group-btn {
  border-radius: 5px 0px 0px 5px;
}

.select-group .btn-check:checked + .select-group-btn {
  background: #E07A5F;
  color: #fff;
}

</style>